
const digest = '58edca65a04734ecebabc5cd319bf3f2976a7f7d8313a8502424426f70bb824a';
const classes = {"item":"_item_grdj4_1","checkboxWrapper":"_checkboxWrapper_grdj4_10","title":"_title_grdj4_17","dayParts":"_dayParts_grdj4_22","times":"_times_grdj4_28","line":"_line_grdj4_34"};
const css = `._item_grdj4_1 {
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  padding: 24px;
}
._item_grdj4_1 ._checkboxWrapper_grdj4_10 {
  min-width: 100px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._item_grdj4_1 ._title_grdj4_17 {
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
}
._item_grdj4_1 ._dayParts_grdj4_22 {
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
}
._item_grdj4_1 ._times_grdj4_28 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._item_grdj4_1 ._line_grdj4_34 {
  width: 2px;
  background-color: #eaedf3;
  height: 55px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  